import classes from "./Home.module.css";
import {
  Sidebar,
  Menu,
  MenuItem,
  SubMenu,
  useProSidebar,
} from "react-pro-sidebar";
import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { useContext } from "react";
import authContext from "../../../../AuthContext/authContext";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { useDispatch, useSelector } from "react-redux";
import appActions from "../../../../ReduxStore/appDataSlice";
import { useEffect } from "react";
import axios from "axios";
import { useMemo } from "react";
import LoadingOverlay from "react-loading-overlay";
import "../../../../assets/css/visitor-css/master.css";
const base_url = process.env.REACT_APP_BASE_URL;
const Home = ({ propComponent, isLoading }) => {
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  console.log("activeCompany", activeCompany);

  const ctx = useContext(authContext);
  console.log("ctx", ctx);
  const userType = ctx.userData.user_type;
  // const [showEmployeeDirectory, setShowEmployeeDirectory] = useState("");
  let showEmployeeDirectory = false;
  if (!(userType === "admin" || userType === "subadmin" || userType === "guard")) {
    showEmployeeDirectory = activeCompany["employeeDirectory"];
  }


  let showCompany = userType === "admin" || userType === "subadmin" && userType != "guard";
  let showCreatePass =
    !(userType === "admin" || userType === "subadmin" || userType == "guard") &&
    (activeCompany["delagateCheck"] || activeCompany["vendorCheck"]);
  let showSubadmin = userType === "admin";
  let showLocation = userType === "Company Manager";
  let showReports =
    userType === "Company Manager" ||
    userType === "location" ||
    userType === "Building Manager" ||
    userType === "company" ||
    userType === "guard";


  let showGuard = userType === "location" || userType === "Building Manager" || userType === "company" || userType === "Company Manager";
  let showBuildingCompany = userType === "Building Manager";
  let showCompanyEmployeeDirectory = userType === "company";
  if (userType === "company") {
    showEmployeeDirectory = false;
  }
  let showLogo = activeCompany?.logo && userType !== "admin" && userType !== "subadmin" ? true : false;
  const path = window.location.pathname;
  const { collapseSidebar } = useProSidebar();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    if (
      userType === "Company Manager" ||
      userType === "location" ||
      userType === "company" ||
      userType === "Building Manager"
    ) {
      // dispatch(
      //   appActions.setActiveCompany({ _id: ctx.userDetailedData.company_id })
      // );
      // localStorage.setItem(
      //   "activeCompany",
      //   JSON.stringify({ _id: ctx.userDetailedData.company_id })
      // );

      if (userType === "Building Manager") {
        return;
      }

      if (userType === "company") {
        dispatch(
          appActions.setActiveBuilding({ _id: ctx.userDetailedData.company_id })
        );

        localStorage.setItem(
          "activeBuilding",
          JSON.stringify({ _id: ctx.userDetailedData.company_id })
        );
      }

      //Check for changes in switches

      let reqObj = {
        method: "GET",
        url: `${base_url}/company/details/${ctx.userDetailedData.company_id}`,
        headers: {
          "Content-Type": "application/javascript",
          Authorization: `Bearer ${ctx.token}`,
        },
      };

      axios(reqObj).then((response) => {
        // console.log("resDataCompany", response);
        dispatch(appActions.setActiveCompany({ ...response.data }));
        localStorage.setItem(
          "activeCompany",
          JSON.stringify({ ...response.data })
        );
      });

      // axios.get("http://localhost:3000/company/details/63ec771ba21f18458f843e65")

      // let reqObj = {
      //   method: "GET",
      //   url: `${base_url}/company/details/${ctx.userDetailedData.company_id}`,
      //   headers: {
      //     "Content-Type": "application/javascript",
      //     Authorization: `Bearer ${ctx.token}`,
      //   },
      // };

      // axios(reqObj)
      //   .then((res) => {
      //     if (userType !== "company") {
      //       setShowEmployeeDirectory(res.data.employeeDirectory);
      //       dispatch(
      //         appActions.setShowEmployeeDirectory(res.data.employeeDirectory)
      //       );
      //       localStorage.setItem(
      //         "showEmployeeDirectory",
      //         res.data.employeeDirectory
      //       );
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    }
  }, []);

  let title = "";

  if (
    !(
      path.includes("dashboard") ||
      path.includes("companies") ||
      path.includes("sub-admin") ||
      path.includes("profile") ||
      path.includes("addSubadmin") ||
      path.includes("editSubadmin") ||
      path.includes("editCompany") ||
      path.includes("editBuilding") ||
      path.includes("addCompany") ||
      path.includes("addCompany") ||
      path.includes("addBuilding")
    )
  ) {
    title = activeCompany ? activeCompany["name"] : "";
  }

  return (
    <>

      <div
        className="wrapper-box"
        style={{ backgroundColor: "transparent", maxWidth: "100%" }}
      >
        <div
          className="container"
          style={{
            maxWidth: "100%",
            margin: "0",
          }}
        >
          <div className={classes.containerAll}>
            <Header />
            <section className={classes.mainContainer} style={{ zIndex: "10" }}>
              {/* <nav className={classes.navbar}> */}
              <Sidebar
                backgroundColor="#003CA6"
                defaultCollapsed={window.screen.width > 1100 ? false : true}
              >
                {/* <div className={classes.navTop}> */}
                {showLogo ? (
                  <div className={classes.logoContainer}>
                    <img
                      src={require("../../../../assets/img/admin-images/Digipass_logo.png")}
                      alt="DigiPass"
                      className={classes.logoImage}
                    />
                    <span className={classes.handshakeIcon}>
                      <svg
                        className={classes.handshakeSvg}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 256 256"
                        width="64"
                        height="64"
                      >
                        <g transform="translate(45 45) scale(1.83)">
                          <path
                            fill="white"
                            stroke="none"
                            d="M 89.689 16.621 c -0.198 -0.188 -0.461 -0.284 -0.739 -0.274 c -6.479 0.321 -13.518 1.398 -22.148 3.389 c -0.271 0.063 -0.504 0.235 -0.643 0.476 c -0.139 0.241 -0.17 0.529 -0.088 0.794 l 0.838 2.704 c -6.363 -2.413 -15.313 -3.802 -23.06 -3.497 c -2.84 0 -6.082 1.409 -9.045 3.5 H 23.089 l 0.839 -2.708 c 0.083 -0.266 0.05 -0.553 -0.088 -0.794 c -0.138 -0.241 -0.371 -0.414 -0.642 -0.476 c -8.63 -1.991 -15.668 -3.068 -22.148 -3.389 c -0.269 -0.012 -0.54 0.085 -0.739 0.274 C 0.112 16.81 0 17.072 0 17.346 v 34.342 c 0 0.553 0.448 1 1 1 h 12.378 c 0.438 0 0.826 -0.285 0.955 -0.704 l 0.472 -1.523 c 10.187 11.872 20.546 22.775 28.634 22.775 c 1.557 0 3.029 -0.411 4.401 -1.29 l 0.211 0.214 c 0.944 0.956 2.209 1.487 3.561 1.495 c 0.011 0 0.021 0 0.032 0 c 1.339 0 2.597 -0.515 3.546 -1.451 c 0.834 -0.825 1.299 -1.873 1.436 -2.956 c 0.93 0.771 2.061 1.18 3.206 1.18 c 1.281 -0.001 2.564 -0.484 3.547 -1.454 c 1.109 -1.096 1.58 -2.581 1.456 -4.025 c 0.446 0.11 0.897 0.185 1.35 0.185 c 1.283 0 2.538 -0.443 3.448 -1.342 c 0.956 -0.944 1.487 -2.209 1.495 -3.561 s -0.507 -2.622 -1.387 -3.507 c -0.368 -0.453 -0.748 -0.888 -1.121 -1.334 l 6.816 -4.149 l 0.23 0.742 c 0.13 0.419 0.517 0.704 0.955 0.704 H 89 c 0.553 0 1 -0.447 1 -1 V 17.346 C 90 17.072 89.888 16.81 89.689 16.621 z M 12.641 50.688 H 2 V 18.403 c 5.806 0.359 12.122 1.335 19.699 3.043 L 12.641 50.688 z M 68.227 62.368 c -1.139 1.126 -3.31 1.005 -4.556 -0.258 c -0.017 -0.017 -0.039 -0.023 -0.057 -0.038 c -0.067 -0.077 -0.118 -0.163 -0.191 -0.237 l -10.95 -11.086 c -0.39 -0.392 -1.021 -0.396 -1.415 -0.009 c -0.393 0.389 -0.396 1.021 -0.009 1.415 l 10.95 11.086 c 0.569 0.575 0.88 1.343 0.875 2.16 c -0.005 0.816 -0.325 1.58 -0.901 2.148 c -1.195 1.183 -3.128 1.168 -4.31 -0.026 l -2.425 -2.455 c -0.002 -0.002 -0.003 -0.004 -0.004 -0.005 l -10.95 -11.085 c -0.389 -0.391 -1.022 -0.396 -1.414 -0.009 c -0.393 0.389 -0.397 1.021 -0.009 1.415 L 53.81 66.47 c 1.182 1.195 1.17 3.129 -0.026 4.31 c -1.196 1.182 -3.13 1.168 -4.31 -0.026 l -13.38 -13.545 c -0.389 -0.392 -1.022 -0.398 -1.414 -0.008 c -0.393 0.388 -0.397 1.021 -0.009 1.414 l 11.711 11.855 c -7.435 3.974 -19.75 -9.239 -30.877 -22.268 l 6.965 -22.487 h 9.815 c -2.741 2.432 -5.001 5.336 -6.092 7.983 c -1.396 3.386 -0.487 5.29 0.521 6.291 c 0.026 0.026 0.054 0.051 0.083 0.074 c 3.843 3.047 7.628 3.815 13.523 -2.283 c 2.001 0.122 3.705 -0.225 5.184 -1.064 c 8.306 5.807 15.937 12.961 22.749 21.343 C 69.435 59.254 69.423 61.188 68.227 62.368 z M 67.318 53.842 c -6.406 -7.41 -13.527 -13.843 -21.216 -19.146 c -0.341 -0.236 -0.793 -0.236 -1.134 -0.001 c -1.322 0.907 -2.939 1.251 -4.944 1.055 c -0.311 -0.034 -0.614 0.084 -0.827 0.31 c -5.585 5.943 -8.344 4.656 -11.109 2.473 c -0.996 -1.039 -0.577 -2.784 -0.046 -4.073 c 2.224 -5.398 10.113 -12.246 15.846 -12.247 c 8.172 -0.313 17.649 1.276 23.786 3.967 l 7.152 23.091 L 67.318 53.842 z M 88 50.688 H 77.358 l -9.058 -29.242 c 7.577 -1.708 13.894 -2.684 19.699 -3.043 V 50.688 z"
                          />
                        </g>
                      </svg>
                    </span>
                    <img
                      src={activeCompany.logo}
                      alt={activeCompany.name}
                      className={classes.logoImage}
                    />
                  </div>
                ) : (
                  <div className={classes.logoContainer} style={{ justifyContent: 'center' }}>
                    <img
                      src={require("../../../../assets/img/admin-images/Digipass_logo.png")}
                      alt="DigiPass"
                      className={classes.logoImage}
                    />
                  </div>
                )}
                <h1 style={{
                  color: "white",
                  width: "100%",
                  textAlign: 'center',
                  margin: '10px 0 5px 0'
                }}>
                  DigiPass
                </h1>
                <p style={{ textAlign: 'center', margin: 0, color: 'white' }}>Visitor Management System</p>
                {/* </div> */}

                <hr className={classes.sideHr} />
                <Menu>
                  {userType !== "guard" && <MenuItem
                    className={classes.setBorder}
                    onClick={() => navigate("/dashboard")}
                    active={path === "/dashboard"}
                    rootStyles={{
                      backgroundColor: path.includes("/dashboard")
                        ? "#F9F9F9"
                        : "transparent",
                    }}
                  >
                    <div
                      className={classes.navItem}
                      style={{
                        color: path.includes("/dashboard")
                          ? "#003CA6"
                          : "#ffffff",
                      }}
                    >
                      {path.includes("/dashboard") && (
                        <img
                          src={require("../../../../assets/img/admin-images/dashboard_blue.png")}
                        />
                      )}
                      {!path.includes("/dashboard") && (
                        <img
                          src={require("../../../../assets/img/admin-images/dashboard_logo.png")}
                        />
                      )}
                      {/* <p>Dashboard</p> */}
                      Dashboard
                    </div>
                  </MenuItem>}

                  {showCompany && (
                    <MenuItem
                      className={classes.setBorder}
                      active={
                        path.includes("/companies") ||
                        path.includes("/location") ||
                        path.includes("/building") ||
                        path.includes("/CompanyEmployeeDirectory") ||
                        path.includes("/visitors-list") ||
                        path.includes("/employeeDirectory") ||
                        path.includes("/terms") ||
                        path.includes("/smsSetting") ||
                        path.includes("/addEmployeeDirectory") ||
                        path.includes("/editEmployee")
                      }
                      rootStyles={{
                        backgroundColor:
                          path.includes("/companies") ||
                            path.includes("/location") ||
                            path.includes("/building") ||
                            path.includes("/CompanyEmployeeDirectory") ||
                            path.includes("/visitors-list") ||
                            path.includes("/employeeDirectory") ||
                            path.includes("/terms") ||
                            path.includes("/smsSetting") ||
                            path.includes("/addEmployeeDirectory") ||
                            path.includes("/editEmployee")
                            ? "#F9F9F9"
                            : "transparent",
                      }}
                      onClick={() => navigate("/companies")}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color:
                            path.includes("/companies") ||
                              path.includes("/location") ||
                              path.includes("/building") ||
                              path.includes("/CompanyEmployeeDirectory") ||
                              path.includes("/visitors-list") ||
                              path.includes("/employeeDirectory") ||
                              path.includes("/terms") ||
                              path.includes("/smsSetting") ||
                              path.includes("/addEmployeeDirectory") ||
                              path.includes("/editEmployee")
                              ? "#003CA6"
                              : "#ffffff",
                        }}
                      >
                        {(path.includes("/companies") ||
                          path.includes("/location") ||
                          path.includes("/building") ||
                          path.includes("/CompanyEmployeeDirectory") ||
                          path.includes("/visitors-list") ||
                          path.includes("/employeeDirectory") ||
                          path.includes("/terms") ||
                          path.includes("/smsSetting") ||
                          path.includes("/addEmployeeDirectory") ||
                          path.includes("/editEmployee")) && (
                            <img
                              src={require("../../../../assets/img/admin-images/company_logo.png")}
                            />
                          )}
                        {!(
                          path.includes("/companies") ||
                          path.includes("/location") ||
                          path.includes("/building") ||
                          path.includes("/CompanyEmployeeDirectory") ||
                          path.includes("/visitors-list") ||
                          path.includes("/employeeDirectory") ||
                          path.includes("/terms") ||
                          path.includes("/smsSetting") ||
                          path.includes("/addEmployeeDirectory") ||
                          path.includes("/editEmployee")
                        ) && (
                            <img
                              src={require("../../../../assets/img/admin-images/company_white.png")}
                            />
                          )}
                        {/* <p>Companies</p> */}
                        Companies
                      </div>
                    </MenuItem>
                  )}

                  {/* Building Manager Company */}

                  {showBuildingCompany && (
                    <MenuItem
                      className={classes.setBorder}
                      active={
                        path.includes("/building") ||
                        path.includes("/location") ||
                        path.includes("/employeeDirectory")
                      }
                      rootStyles={{
                        backgroundColor:
                          path.includes("/building") ||
                            path.includes("/location") ||
                            path.includes("/employeeDirectory")
                            ? "#F9F9F9"
                            : "transparent",
                      }}
                      onClick={() => navigate("/building")}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color:
                            path.includes("/building") ||
                              path.includes("/location") ||
                              path.includes("/employeeDirectory")
                              ? "#003CA6"
                              : "#ffffff",
                        }}
                      >
                        {(path.includes("/building") ||
                          path.includes("/location") ||
                          path.includes("/employeeDirectory")) && (
                            <img
                              src={require("../../../../assets/img/admin-images/company_logo.png")}
                            />
                          )}
                        {!(
                          path.includes("/building") ||
                          path.includes("/location") ||
                          path.includes("/employeeDirectory")
                        ) && (
                            <img
                              src={require("../../../../assets/img/admin-images/company_white.png")}
                            />
                          )}
                        {/* <p>Companies</p> */}
                        Company
                      </div>
                    </MenuItem>
                  )}
                  {activeCompany?.guardCheck && showGuard && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes("/guard")
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => {
                        navigate("/guard");
                      }}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("/guard")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("/guard") && (
                          <img
                            src={require("../../../../assets/img/admin-images/company_logo.png")}
                          />
                        )}
                        {!path.includes("/guard") && (
                          <img
                            src={require("../../../../assets/img/admin-images/company_white.png")}
                          />
                        )}
                        {/* <p>My Profile</p> */}
                        Guard
                      </div>
                    </MenuItem>
                  )}
                  {showLocation && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes("/location")
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => {
                        navigate("/location");
                      }}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("/location")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("/location") && (
                          <img
                            src={require("../../../../assets/img/admin-images/company_logo.png")}
                          />
                        )}
                        {!path.includes("/location") && (
                          <img
                            src={require("../../../../assets/img/admin-images/company_white.png")}
                          />
                        )}
                        {/* <p>My Profile</p> */}
                        Location
                      </div>
                    </MenuItem>
                  )}

                  {showReports && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes("/visitors-list")
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => {
                        navigate("/visitors-list");
                      }}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("/visitors-list")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("/visitors-list") && (
                          <img
                            src={require("../../../../assets/img/admin-images/reports_blue.png")}
                          />
                        )}
                        {!path.includes("/visitors-list") && (
                          <img
                            src={require("../../../../assets/img/admin-images/reports.png")}
                          />
                        )}
                        {/* <p>My Profile</p> */}
                        Reports
                      </div>
                    </MenuItem>
                  )}

                  {showEmployeeDirectory && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes("/employeeDirectory")
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => {
                        navigate("/employeeDirectory");
                        if (userType !== "location") {
                          dispatch(
                            appActions.setActiveLocation({
                              _id: "",
                              location: "All",
                            })
                          );
                          localStorage.setItem(
                            "activeLocation",
                            JSON.stringify({ _id: "", location: "All" })
                          );
                        }
                      }}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("/employeeDirectory")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("/employeeDirectory") && (
                          <img
                            src={require("../../../../assets/img/admin-images/copy.png")}
                          />
                        )}
                        {!path.includes("/employeeDirectory") && (
                          <img
                            src={require("../../../../assets/img/admin-images/copy_white.png")}
                          />
                        )}
                        {/* <p>My Profile</p> */}
                        Employee Directory
                      </div>
                    </MenuItem>
                  )}

                  {/* Building Company Employee Listing */}
                  {showCompanyEmployeeDirectory && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes(
                          "/CompanyEmployeeDirectory"
                        )
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => {
                        navigate("/CompanyEmployeeDirectory");
                        // if (userType !== "location") {
                        //   dispatch(
                        //     appActions.setActiveLocation({
                        //       _id: "",
                        //       location: "All",
                        //     })
                        //   );
                        //   localStorage.setItem(
                        //     "activeLocation",
                        //     JSON.stringify({ _id: "", location: "All" })
                        //   );
                        // }
                      }}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("/CompanyEmployeeDirectory")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("/CompanyEmployeeDirectory") && (
                          <img
                            src={require("../../../../assets/img/admin-images/copy.png")}
                          />
                        )}
                        {!path.includes("/CompanyEmployeeDirectory") && (
                          <img
                            src={require("../../../../assets/img/admin-images/copy_white.png")}
                          />
                        )}
                        Employee Directory
                      </div>
                    </MenuItem>
                  )}

                  {showSubadmin && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes("/sub-admin")
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => navigate("/sub-admin")}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("/sub-admin")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("/sub-admin") && (
                          <img
                            src={require("../../../../assets/img/admin-images/subadmin_blue.png")}
                          />
                        )}
                        {!path.includes("/sub-admin") && (
                          <img
                            src={require("../../../../assets/img/admin-images/subadmin_logo.png")}
                          />
                        )}
                        {/* <p>Sub Admin</p> */}
                        Sub Admin
                      </div>
                    </MenuItem>
                  )}

                  {showCreatePass && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: path.includes("special")
                          ? "#F9F9F9"
                          : "transparent",
                      }}
                      onClick={() => navigate("/special-visitors-list")}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: path.includes("special")
                            ? "#003CA6"
                            : "#ffffff",
                        }}
                      >
                        {path.includes("special") && (
                          <img
                            src={require("../../../../assets/img/admin-images/special_pass_blue.png")}
                          />
                        )}
                        {!path.includes("special") && (
                          <img
                            src={require("../../../../assets/img/admin-images/special_pass_white.png")}
                          />
                        )}
                        {/* <p>My Profile</p> */}
                        Special Pass
                      </div>
                    </MenuItem>
                  )}
                  <MenuItem
                    className={classes.setBorder}
                    rootStyles={{
                      backgroundColor: path.includes("/profile")
                        ? "#F9F9F9"
                        : "transparent",
                    }}
                    onClick={() => navigate("/profile")}
                  >
                    <div
                      className={classes.navItem}
                      style={{
                        color: path.includes("/profile")
                          ? "#003CA6"
                          : "#ffffff",
                      }}
                    >
                      {path.includes("/profile") && (
                        <img
                          src={require("../../../../assets/img/admin-images/gear_blue.png")}
                        />
                      )}
                      {!path.includes("/profile") && (
                        <img
                          src={require("../../../../assets/img/admin-images/gear.png")}
                        />
                      )}
                      {/* <p>My Profile</p> */}
                      My Profile
                    </div>
                  </MenuItem>

                  {window.screen.width <= 1100 && (
                    <MenuItem
                      className={classes.setBorder}
                      rootStyles={{
                        backgroundColor: "transparent",
                      }}
                      onClick={() => ctx.logout()}
                    >
                      <div
                        className={classes.navItem}
                        style={{
                          color: "#ffffff",
                        }}
                      >
                        <img
                          src={require("../../../../assets/img/admin-images/logout.png")}
                        />
                        Logout
                      </div>
                    </MenuItem>
                  )}

                  {/* logout */}
                  {/* <MenuItem
                className={classes.setBorder}
                rootStyles={{
                  backgroundColor: path.includes("/terms")
                    ? "#F9F9F9"
                    : "transparent",
                }}
                onClick={() => navigate("/terms")}
              >
                <div
                  className={classes.navItem}
                  style={{
                    color: path.includes("/terms") ? "#003CA6" : "#ffffff",
                  }}
                >
                  {path.includes("/terms") && (
                    <img src={require("../../../../assets/img/admin-images/terms_blue.png")} />
                  )}
                  {!path.includes("/terms") && (
                    <img src={require("../../../../assets/img/admin-images/terms_logo.png")} />
                  )}
                  
                  Terms & Conditions
                </div>
              </MenuItem> */}
                </Menu>
              </Sidebar>
              {/* </nav> */}
              <section className={classes.container}>
                <div className={classes.contentHead}>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      activeCompany.type === "Company"
                        ? navigate("/location")
                        : navigate("/building");
                    }}
                  >
                    {/* {path.includes("location") ||
                path.includes("employeeDirectory") ||
                path.includes("visitors-list") ||
                path.includes("terms") ||
                path.includes("smsSetting")
                  ? activeCompany.name
                  : ""} */}
                    {title}
                  </p>
                </div>

                <div className={classes.tableContainer}>{propComponent}</div>
                <Footer />
              </section>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
